export const Map = {
  MAP_DISTANCE_RANGE: 25000,
};

export const locality = {
  METRO: "Metro",
  SEMI_METRO: "Semi Metro",
  OTHERS: "Others",
};

export const baseUrlSDK = {
  BASE_URL: "https://communication.goapptiv.one/",
  HTTP_SCHEME: "https" as "http" | "https",
};

export const sampleAcknowledgementScope = {
  SELF: "self",
  CHILDREN: "children",
}

export const fileExtensions = {
IMAGE_EXTENSIONS: ["image/png", "image/jpeg", "image/jpg"],
PDF_EXTENSION: "application/pdf"
}

export const fileSize = {
  FILE_SIZE: 10 * 1024 * 1024
}

// utils/quarter-utils.ts
export const MONTH_ORDER = [
  "Jan", "Feb", "Mar",
  "Apr", "May", "Jun",
  "Jul", "Aug", "Sep",
  "Oct", "Nov", "Dec",
];

export const QUARTERS = {
  Q1: ["Jan", "Feb", "Mar"],
  Q2: ["Apr", "May", "Jun"],
  Q3: ["Jul", "Aug", "Sep"],
  Q4: ["Oct", "Nov", "Dec"],
} as const;
